module.exports = __webpack_public_path__ + "img/btn_menu-open.1fd3f7a0.png";